import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { tokens } from '../tokens.generated';

export interface T3PageHeaderProps {
  title: string;
  /** Right-aligned actions slot (buttons etc.). */
  actions?: ReactNode;
}

/** Display-font page title with the brand's gold underline rule. */
export function T3PageHeader({ title, actions }: T3PageHeaderProps) {
  return (
    <Box component="header" sx={{ mb: 4 }}>
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between" spacing={2}>
        <Typography variant="h3" component="h1">
          {title}
        </Typography>
        {actions ? <Box>{actions}</Box> : null}
      </Stack>
      <Box
        aria-hidden
        sx={{
          mt: 1,
          height: 5,
          width: 96,
          borderRadius: `${tokens.radius.pill}px`,
          backgroundColor: tokens.color.gold,
        }}
      />
    </Box>
  );
}
